module.exports = __webpack_public_path__ + "img/symmetry_cn.fbffa29.jpg";